// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2JXlp","container":"styles_container__2b33p","title":"styles_title__1KeXf","wrapper":"styles_wrapper__1Wr-s","answer":"styles_answer__3xhrZ"};